import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";
import axios from 'axios';

function Rank() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [analytics, setAnalytics] = useState([]);
  const [tabelLoading, setTableLoading] = useState(false);
  const [deposits, setDeposits] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [user_id, setUserID] = useState("");
  const [client_id, setClientId] = useState("");
  const [deposit_asset, setSepositAsset] = useState("");
  const [network_type, setNetworkType] = useState("");
  const [from_address, setFromAddress] = useState("");
  const [txn_hash, setTxnHash] = useState("");
  const [txnstatus, setStatus] = useState("");
  const [per_page, setPerPage] = useState("");
  const [viewData, setViewData] = useState("");


  const [editPaidAmount, setEditPaidAmount] = useState("");
  const [editFromAddress, setEditFromAddress] = useState("");
  const [editToAddress, setEditToAddress] = useState("");
  const [editTxnHash, setEditTxnHash] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [deposit_id, setDepositId] = useState([]);
  const [error, setError] = useState("");
  const [isRank, setRank] = useState(true)
  const [RankList, setRankList] = useState([])



  useEffect(() => {

    fetchDepositData(1);
    fetchRankList();
  }, []);


  const fetchDepositData = async (page) => {
    console.log('Token ', authToken);

    const searchData = {
      page: page,
      client_id: client_id,
      user_id: user_id,
      deposit_asset: deposit_asset,
      network_type: network_type,
      from_address: from_address,
      status: txnstatus,
      txn_hash: txn_hash
    };

    console.log('Reach Data', searchData);

    try {
      const deposit = await fetch(`${baseurl}/client/deposit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(searchData),
      });

      if (deposit.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return; // Stop further processing
      }

      const depositResult = await deposit.json();
      console.log('Static data', depositResult);

      if (depositResult.status) {
        setAnalytics(depositResult.analytics);
        setDeposits(depositResult.data);
        setPagination(depositResult.pagination);
        setTableLoading(true);
      } else {
        // Handle any error condition
        setTableLoading(true);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };


  const passData = (depositData) => {
    setDepositId(depositData);
    setViewData(depositData);
    setEditPaidAmount(depositData.paid_amount);
    setEditFromAddress(depositData.from_address);
    setEditToAddress(depositData.to_address);
    setEditTxnHash(depositData.txn_hash);
    setEditStatus(depositData.txn_hash);
  };



  const fetchRankList = async () => {
    try {
      const response = await axios.get(`${baseurl}/rank-list`, {
        headers: {
          Authorization: `Bearer ${authToken}`, // Replace with actual token
        },
      });

      if (response.data.status) {
        console.log("Rank list fetched:", response.data.data);

        setRankList(response.data.data);
        // You can store it in state if using React
        // setRankList(response.data.data);
      } else {
        console.error("Failed:", response.data.message);
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching rank list:", error);
      alert(error.response?.data?.message || "Request failed");
    }
  };





  const updateDeposit = async () => {

    console.log(editPaidAmount, editFromAddress, editToAddress, editTxnHash, editStatus)

    if (!deposit_id) return setError("Try again.");
    if (!editPaidAmount) return setError("Paid amount id required.");
    if (!editFromAddress) return setError("From address is required");
    if (!editToAddress) return setError("To address is reuired.");
    if (!editTxnHash) return setError("Txn Hash is required.");
    if (!editStatus) return setError("Status is required.");
    if (!authToken) return setError("Authentication is required.");


    const formData = {
      deposit_id: deposit_id.id,
      paid_amount: editPaidAmount,
      from_address: editFromAddress,
      to_address: editToAddress,
      txn_hash: editTxnHash,
      status: editStatus
    };

    console.log("Sending Data:", formData);

    try {
      const response = await fetch(`${baseurl}/client/deposit-update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json(); // Get raw response
      console.log("Raw API Response:", data); // Log response before parsing


      if (data.status) {
        toast.success(data.message)
        window.location.href = "";
      }
      else {
        toast.error(data.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Network error. Please check your connection and try again.");
      toast.error("Network error. Please check your connection and try again.");
    }
  }


  const handlePageChange = async (page) => {

    setTableLoading(false)
    fetchDepositData(page);
  }

  const searchData = () => {

    setTableLoading(false)
    fetchDepositData(1);
  }
  return (
    <>
      <Header>
        <Auth />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Rank!</h4>

              </div>
            </div>
            {/* End Page Header */}



            <div className="mt-3 mb-3">
              <button className="btn btn-primary btn-sm" onClick={() => setRank(true)}>Rank List</button> <button className="btn btn-primary btn-sm" onClick={() => setRank(false)}>Achiver List</button>
            </div>

            {isRank ?

              <div className="row">
                <div className="col-md-12 col-lg-12 col-xl-12">
                  <div className="card card-table">
                    <div className=" card-header p-0 d-flex justify-content-between mt-3">
                      <h3 className="card-title mb-1 text-primary">Rank List</h3>
                    </div>
                    <div className="table-responsive country-table">
                      {tabelLoading ? (
                        <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                          <thead>
                            <tr>
                              <th className="wd-lg-25p">Image</th>
                              <th className="wd-lg-25p">Name</th>
                              <th className="wd-lg-25p">Direct Referral</th>
                              <th className="wd-lg-25p">Team Size</th>
                              <th className="wd-lg-25p">Condition</th>
                              <th className="wd-lg-25p">Team Business</th>
                              <th className="wd-lg-25p">Reward</th>
                            </tr>
                          </thead>

                          <tbody>
                            {RankList.length > 0 ? (
                              RankList.map((ranks, index) => (
                                <tr key={index}>
                                  <td> <img className="rounded-circle" width={37} src={ranks.rank_image || 'https://apiuser.ride2luxury.in/images/profileImage/avtarImage-1.avif'} /></td>
                                  <td> {ranks.rank_name || 'N/A'} </td>
                                  <td> {ranks.direct_referral || '0'} </td>
                                  <td> {ranks.team_size || 'N/A'} </td>
                                  <td> {ranks.condition || 'N/A'} </td>
                                  <td> ${ranks.team_business || 'N/A'} </td>
                                  <td> ${ranks.reward || 'N/A'} </td>


                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      ) : (
                        <div className="text-center">
                          <div class="d-flex justify-content-center mb-4">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </div>
                      )}


                    </div>
                  </div>
                </div>
              </div>
              :
              <>
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-xl-12">
                    <div className="card card-table ">
                      <div className="row">

                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                          <div className="mt-3 ">
                            <lavel>Enter Asset</lavel>
                            <input type="text" value={deposit_asset} onChange={(e) => setSepositAsset(e.target.value)} className="form-control" placeholder="Enter Asster USDT BNB" />
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                          <div className="mt-3 ">
                            <lavel>Network Type</lavel>
                            <input type="text" value={network_type} onChange={(e) => setNetworkType(e.target.value)} className="form-control" placeholder="Enter BEP20, ERC20 , SOL20" />
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                          <div className="mt-3 ">
                            <lavel>Deposit Address</lavel>
                            <input type="text" value={from_address} onChange={(e) => setFromAddress(e.target.value)} className="form-control" placeholder="Enter Clinet Id" />
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                          <div className="mt-3 ">
                            <lavel>Txn Hash</lavel>
                            <input type="text" value={txn_hash} onChange={(e) => setTxnHash(e.target.value)} className="form-control" placeholder="Enter Clinet Id" />
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                          <div className="mt-3">
                            <label>Status</label>
                            <select className="form-control" value={txnstatus} onChange={(e) => setStatus(e.target.value)}>
                              <option value="all">All</option>
                              <option value="open">Open</option>
                              <option value="pending">Pending</option>
                              <option value="success">Success</option>
                              <option value="failed">Failed</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                          <div className="mt-3 text-end">

                            <button onClick={searchData} className="btn btn-primary btn-block mt-3">Search Data</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* row closed */}

                {/* row opened */}
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-xl-12">
                    <div className="card card-table">
                      <div className=" card-header p-0 d-flex justify-content-between mt-3">
                        <h3 className="card-title mb-1 text-primary">Deposit History</h3>
                      </div>
                      <div className="table-responsive country-table">
                        {tabelLoading ? (
                          <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                            <thead>
                              <tr>
                                <th className="wd-lg-25p">User</th>
                                <th className="wd-lg-25p">User Name</th>
                                <th className="wd-lg-25p">DEPOSIT</th>
                                <th className="wd-lg-25p">ASSET</th>
                                <th className="wd-lg-25p">Date Time</th>
                                <th className="wd-lg-25p">STATUS</th>
                                <th className="wd-lg-25p">ACTION</th>
                              </tr>
                            </thead>

                            <tbody>
                              {deposits.length > 0 ? (
                                deposits.map((depositData, index) => (
                                  <tr key={index}>
                                    <td> <img className="rounded-circle" width={37} src={depositData.profile_image || 'https://apiuser.ride2luxury.in/images/profileImage/avtarImage-1.avif'} /></td>
                                    <td> {depositData.user_name || 'N/A'} </td>
                                    <td> {depositData.deposit_amount || '0'} </td>
                                    <td> {depositData.deposit_asset || 'N/A'} </td>
                                    <td> {depositData.date_time || 'N/A'} </td>
                                    <td>
                                      {depositData && depositData.status
                                        ? depositData.status === 'success' ? (
                                          <span className="badge bg-success">success</span>
                                        ) : (
                                          <span className="badge bg-danger">{depositData.status} </span>
                                        ) : 'N/A'}
                                    </td>
                                    <td>
                                      <a href="#" onClick={() => passData(depositData)} className="btn btn-sm btn-primary" data-bs-toggle="modal"
                                        data-bs-target="#exampleModal">
                                        <i className="fa fa-eye"></i>
                                      </a>
                                      &nbsp;&nbsp;&nbsp;&nbsp;
                                      <a data-bs-effect="effect-scale" onClick={() => passData(depositData)} data-bs-toggle="modal" href="#modaldemo8" className="btn btn-sm btn-warning">
                                        <i className="fa fa-edit"></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td>No Data Found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        ) : (
                          <div className="text-center">
                            <div class="d-flex justify-content-center mb-4">
                              <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          </div>
                        )}


                      </div>
                      <div class="gridjs-footer">
                        <div class="gridjs-pagination">
                          <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                          <div className="gridjs-pages text-end">
                            {/* Previous Button */}
                            <button tabIndex="0" role="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                            {/* First Page */}
                            <button tabIndex="0" role="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                            {/* Ellipsis if needed */}
                            {pagination.current_page > 3 && <span>...</span>}

                            {/* Middle Pages (2 dynamic pages around current) */}
                            {Array.from({ length: 5 }, (_, i) => {
                              const page = pagination.current_page - 2 + i;
                              if (page > 1 && page < pagination.last_page) {
                                return (
                                  <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                    aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                    {page}
                                  </button>
                                );
                              }
                              return null;
                            })}

                            {/* Ellipsis if needed */}
                            {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                            {/* Last Page */}
                            {pagination.last_page > 1 && (
                              <button tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                                onClick={() => handlePageChange(pagination.last_page)}>
                                {pagination.last_page}
                              </button>
                            )}

                            {/* Next Button */}
                            <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                              Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }



          </div>
        </div>


        <ToastContainer />
      </Header>


      <Footer />

    </>
  )
}

export default Rank